// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_box1__Bk1LT {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48%;
  height: 250px;
  border-radius: 8px;
  border: 1px dashed black;
  background: rgba(41, 121, 255, 0.1);
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_uploadVideo__dQy03 {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #4154f1;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_pasteVideo__XJ5Uu {
  background: #fff;
  color: gray;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  outline: none;
  border: none;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_pVal__-SNP9 {
  margin-top: 1rem;
  width: 300px;
}
.style_nextBtn__COQmf {
  font-weight: 500;
}

/* alert */
.style_step2Box__Mht0V {
  margin-top: 2rem;
  height: 60vh;
  overflow: auto;
}
.style_itemBox__Wzwfd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #2979ff;
  color: #fff;
  font-weight: 500;
  padding: 10px 20px;
  margin-block: 10px;
  border-radius: 8px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_itemBox2__4\\+vOp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(41, 121, 255, 0.2);
  color: #2979ff;
  font-weight: 500;
  padding: 10px 20px;
  margin-block: 10px;
  border-radius: 8px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_itemBoxAdd__Uzatm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(41, 121, 255, 0.2);
  color: #2979ff;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  padding: 10px 20px;
  margin-block: 10px;
  border-radius: 8px;
}
.style_removeBtn__vstwV {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #fff;
  border-radius: 20px;
  padding: 5px 15px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_markBondary__jl5wp {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #2979ff;
  color: #fff;
  border-radius: 20px;
  padding: 5px 15px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_flexDiv__sijx3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: rgba(41, 121, 255, 0.1);
  border-radius: 10px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_flexDiv__sijx3 > span {
  font-weight: 600;
  font-size: 16px;
}
.style_flexDiv__sijx3 > div > span {
  font-weight: 600;
  font-size: 16px;
}

.style_titleHome__wfwZn {
  font-size: 20px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  border: none;
  outline: none;
}

.style_saveForLater__AVCOG {
  margin-right: 10px;
  background-color: rgba(41, 121, 255, 0.1);
  border-radius: 12px;
  border: none;
  padding: 10px 20px;
  font-weight: 500;
  color: black;
}

.style_cancel__hq3xM {
  background: rgba(176, 11, 11, 0.8);
  color: #fff;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  border-radius: 12px;
  border: none;
  padding: 8px 20px;
}

/* step1 */

.style_uploadBtn__xvWaz {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #fff;
  margin-right: 10px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_connectToCamera__FLf1P {
  background: #2979ff;
  border: none;
  padding: 8px 20px;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_navHeader__KlCHX {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background: #f5f6fc;
  height: 50px;
  padding-inline: 10px;
  margin-right: 1rem;
}

.style_activeHeader__rK\\+qJ {
  color: #2979ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #fff;
  width: 150px;
  height: 40px;
  cursor: pointer;
}
.style_dactiveHeader__k\\+B2r {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  color: rgba(0, 0, 0, 0.5);
  width: 150px;
  height: 40px;
  cursor: pointer;
}
.style_inprogress__YZLN8 {
  display: flex;
  align-items: center;
  padding-inline: 10px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #fff;
  width: 100%;
  height: 60px;
  margin-top: 2rem;
}
.style_boxLast__jr3oE {
  width: 100%;
  border-radius: 12px;
  background: rgba(41, 121, 255, 0.1);
  margin-top: 2rem;
  padding: 15px 20px;
}
.style_videoBox__JKMXp {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.style_btn1__ULPvQ {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff;
  height: 40px;
  border: none;
  margin-right: 10px;
}

.style_countBox__ZbOVB {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-radius: 12px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  border-radius: 8px;
}
.style_numberBoxHead__34mri {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* home comp */

.style_cardHome__ZOHXN {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  width: 100%;
  height: 400px;
  border-radius: 8px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_scrollableDiv__pV10V {
  display: flex;
  padding: 10px;
  height: 350px;
  width: 100%;
  overflow-y: scroll;
  overflow: auto;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_card__LrEis {
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
    rgb(209, 213, 219) 0px 0px 0px 1px inset;
  padding: 10px;
  border-radius: 10px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_ImgBox__efFKw {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
  height: 12rem;
  margin: 5px;
  border-radius: 10px;
  overflow: hidden;
}
.style_ImgBox__efFKw > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.style_eventContent__9pa3W {
  margin: 5px;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_warehouseBox__BgAEq {
  display: flex;
  align-items: center;
  padding: 0 0 5px 5px;
  color: #7e868c;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_date__CGqs1 {
  display: flex;
  align-items: center;
  color: #7e868c;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_alertName__MEXWY {
  font-size: 1rem;
  color: #7e868c;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 5px;
  text-transform: capitalize;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_date__CGqs1 > div {
  font-size: 0.8rem;
  padding-inline: 5px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_footer__wfmH7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.75rem;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_footerDiv__-nnG9 {
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_footerDiv__-nnG9 > span {
  font-size: 14px;
  line-height: 18px;
  color: green;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_loading__ATmp6 {
  display: flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
}
.style_viewBtn__dSLvK {
  position: absolute;
  display: flex;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  justify-content: center;
  align-items: center;
  top: 20px;
  right: 20px;
  width: 25px;
  height: 25px;
  border-radius: 26px;
  background: #f1eded;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

/* Model css */
.style_imgBoxView__6PyOW {
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
}
.style_imgBoxView__6PyOW > img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  border-radius: 12px;
}

.style_crossBtn__e1\\+JW {
  position: absolute;
  top: -2px;
  right: 7px;
  font-weight: 700;
  cursor: pointer;
}
.style_commentBox__rZ6dR {
  height: 150px;
  overflow: auto;
  margin-bottom: 0.5rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 8px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_commentHeding__zEL3d {
  font-weight: 700;
  font-family: "Nunito", sans-serif;
}
.style_comment__0CRE6 {
  margin-top: 10px;
  padding-left: 10px;
}
.style_userName__m0cXT {
  margin-inline: 5px;
  font-weight: 700;
  font-family: "Nunito", sans-serif;
}
.style_commentText__frWOl {
  margin-top: 0;
  padding-inline: 35px;
  padding-top: 0;
  font-weight: 400;
  font-size: 13px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_time__JQ8\\+w {
  font-weight: 500;
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  margin-inline: 8px;
}

.style_modelFooter__Eejni {
  height: 60px;
  display: flex;
  align-items: center;
  padding-inline: 10px;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_modelFooter__Eejni > input {
  display: flex;
  flex: 1 1;
  height: 40px;
  margin-inline-start: 10px;
  padding-inline: 15px;
  border-radius: 40px;
  border: none;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  outline: none;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_sendBtn__fFDYt {
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  cursor: pointer;
  position: absolute;
  bottom: 29px;
  right: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #5d87ff;
  width: 35px;
  height: 35px;
  border-radius: 40px;
}
/* img overlay */

.style_container__QRVSx {
  position: relative;
  cursor: pointer;
}

.style_image__eC0AA {
  opacity: 1;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.style_middle__VpEha {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_container__QRVSx:hover .style_image__eC0AA {
  filter: blur(8px);
}

.style_container__QRVSx:hover .style_middle__VpEha {
  opacity: 1;
}

.style_text__dQkSx {
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  font-family: "Nunito", sans-serif;
}

.style_tagsName__iCPyS {
  font-weight: 700;
  text-transform: capitalize;
  color: black;
  font-family: "Nunito", sans-serif;
}

.style_actionBtn__YIPrD {
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  cursor: pointer;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_disabled__ITxqQ {
  opacity: 0.4;
  cursor: not-allowed !important;
}

.style_userBox__02VxE {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_userName__m0cXT {
  font-size: 0.9rem;
  color: #11181c;
  line-height: 1.25rem;
  text-transform: capitalize;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_userEmail__sUu1r {
  font-size: 0.75rem;
  color: #7e868c;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}

.style_cardBox__YSV5J {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  margin-bottom: 1rem;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_cardOne__4-JPK {
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  width: 90%;
  height: 150px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.style_NuberStyle__1guRP {
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  margin-inline: 6px;
}

.style_countVal__jddzq {
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  margin-top: 0.6rem;
  font-size: 26px;
  color: #5d87ff;
  font-weight: 600;
}

.style_loderBox__Dq9ns {
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.style_closeBtn__PR7wD {
  font-weight: 600;
  font-family: "Nunito", sans-serif;
  position: absolute;
  top: 10px;
  color: red;
  cursor: pointer;
  right: 10px;
}

.style_buttonAddRole__-qd-5 {
  align-items: center;
  background-color: #5d87ff;
  border: 0;
  border-radius: 8px;
  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
  box-sizing: border-box;
  color: #ffffff;
  display: flex;
  font-size: 14px;
  justify-content: center;
  line-height: 1em;
  max-width: 100%;
  padding: 13px 15px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
  font-weight: 600;
  font-family: "Nunito", sans-serif;
}
.style_forResponsive__BppiR {
  width: 1400px;
  overflow: auto;
}

/* new */

.style_boxPlay1__c30hD {
  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,
    rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
  min-height: 50vh;
  background: #fff;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  padding-bottom: 1rem;
}
.style_boxPlay2__cYJ6V {
  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,
    rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
  height: 73vh;
  overflow: auto;
  background: #fff;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  padding-bottom: 1rem;
  overflow: auto;

}

.style_sources__WcQBI {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background: #fff;
  padding: 0.5rem 1rem;
  border-radius: 5px;
}

.style_lc__-xK5N {
  border: 1px solid rgb(93, 91, 91);
  padding: 0.5rem;
  border-radius: 5px;
  min-width: 47%;
  margin-right: 1rem;
  padding-bottom: 1rem;
}

.style_overflowBox__wQFKY {
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  padding-top: 0.2rem;
}

.style_boxforsource__vx5n8{
  border: 1px solid rgb(93, 91, 91);
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/home/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB;0CACwC;EACxC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,cAAc;;AAEd;EACE;0CACwC;EACxC,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB;4CAC0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,8CAA8C;EAC9C,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb;0CACwC;EACxC,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,cAAc;AACd;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ;0CACwC;EACxC,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC;0CACwC;EACxC,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,QAAQ;;AAER;EACE;yCACuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE;yCACuC;EACvC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;;AAEhB;;AAEA;EACE;0CACwC;EACxC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".box1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48%;\n  height: 250px;\n  border-radius: 8px;\n  border: 1px dashed black;\n  background: rgba(41, 121, 255, 0.1);\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.uploadVideo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #4154f1;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.pasteVideo {\n  background: #fff;\n  color: gray;\n  font-weight: 500;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  outline: none;\n  border: none;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.pVal {\n  margin-top: 1rem;\n  width: 300px;\n}\n.nextBtn {\n  font-weight: 500;\n}\n\n/* alert */\n.step2Box {\n  margin-top: 2rem;\n  height: 60vh;\n  overflow: auto;\n}\n.itemBox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #2979ff;\n  color: #fff;\n  font-weight: 500;\n  padding: 10px 20px;\n  margin-block: 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.itemBox2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(41, 121, 255, 0.2);\n  color: #2979ff;\n  font-weight: 500;\n  padding: 10px 20px;\n  margin-block: 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.itemBoxAdd {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(41, 121, 255, 0.2);\n  color: #2979ff;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  padding: 10px 20px;\n  margin-block: 10px;\n  border-radius: 8px;\n}\n.removeBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  background: #fff;\n  border-radius: 20px;\n  padding: 5px 15px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.markBondary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  background: #2979ff;\n  color: #fff;\n  border-radius: 20px;\n  padding: 5px 15px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.flexDiv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background: rgba(41, 121, 255, 0.1);\n  border-radius: 10px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.flexDiv > span {\n  font-weight: 600;\n  font-size: 16px;\n}\n.flexDiv > div > span {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.titleHome {\n  font-size: 20px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  border: none;\n  outline: none;\n}\n\n.saveForLater {\n  margin-right: 10px;\n  background-color: rgba(41, 121, 255, 0.1);\n  border-radius: 12px;\n  border: none;\n  padding: 10px 20px;\n  font-weight: 500;\n  color: black;\n}\n\n.cancel {\n  background: rgba(176, 11, 11, 0.8);\n  color: #fff;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  border-radius: 12px;\n  border: none;\n  padding: 8px 20px;\n}\n\n/* step1 */\n\n.uploadBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  background: #fff;\n  margin-right: 10px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.connectToCamera {\n  background: #2979ff;\n  border: none;\n  padding: 8px 20px;\n  color: #fff;\n  border-radius: 8px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.navHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px;\n  background: #f5f6fc;\n  height: 50px;\n  padding-inline: 10px;\n  margin-right: 1rem;\n}\n\n.activeHeader {\n  color: #2979ff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  background: #fff;\n  width: 150px;\n  height: 40px;\n  cursor: pointer;\n}\n.dactiveHeader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  color: rgba(0, 0, 0, 0.5);\n  width: 150px;\n  height: 40px;\n  cursor: pointer;\n}\n.inprogress {\n  display: flex;\n  align-items: center;\n  padding-inline: 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  background: #fff;\n  width: 100%;\n  height: 60px;\n  margin-top: 2rem;\n}\n.boxLast {\n  width: 100%;\n  border-radius: 12px;\n  background: rgba(41, 121, 255, 0.1);\n  margin-top: 2rem;\n  padding: 15px 20px;\n}\n.videoBox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.btn1 {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #fff;\n  height: 40px;\n  border: none;\n  margin-right: 10px;\n}\n\n.countBox {\n  margin-left: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 150px;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  border-radius: 8px;\n}\n.numberBoxHead {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n/* home comp */\n\n.cardHome {\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  width: 100%;\n  height: 400px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.scrollableDiv {\n  display: flex;\n  padding: 10px;\n  height: 350px;\n  width: 100%;\n  overflow-y: scroll;\n  overflow: auto;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.card {\n  position: relative;\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,\n    rgb(209, 213, 219) 0px 0px 0px 1px inset;\n  padding: 10px;\n  border-radius: 10px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.ImgBox {\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;\n  height: 12rem;\n  margin: 5px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.ImgBox > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.eventContent {\n  margin: 5px;\n  margin-bottom: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.warehouseBox {\n  display: flex;\n  align-items: center;\n  padding: 0 0 5px 5px;\n  color: #7e868c;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.date {\n  display: flex;\n  align-items: center;\n  color: #7e868c;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.alertName {\n  font-size: 1rem;\n  color: #7e868c;\n  font-weight: 500;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  text-transform: capitalize;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.date > div {\n  font-size: 0.8rem;\n  padding-inline: 5px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.75rem;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.footerDiv {\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.footerDiv > span {\n  font-size: 14px;\n  line-height: 18px;\n  color: green;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.loading {\n  display: flex;\n  height: 50px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 5rem;\n}\n.viewBtn {\n  position: absolute;\n  display: flex;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  justify-content: center;\n  align-items: center;\n  top: 20px;\n  right: 20px;\n  width: 25px;\n  height: 25px;\n  border-radius: 26px;\n  background: #f1eded;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n/* Model css */\n.imgBoxView {\n  width: 100%;\n  overflow: hidden;\n  border-radius: 12px;\n}\n.imgBoxView > img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  border-radius: 12px;\n}\n\n.crossBtn {\n  position: absolute;\n  top: -2px;\n  right: 7px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.commentBox {\n  height: 150px;\n  overflow: auto;\n  margin-bottom: 0.5rem;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  border-radius: 8px;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.5rem;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.commentHeding {\n  font-weight: 700;\n  font-family: \"Nunito\", sans-serif;\n}\n.comment {\n  margin-top: 10px;\n  padding-left: 10px;\n}\n.userName {\n  margin-inline: 5px;\n  font-weight: 700;\n  font-family: \"Nunito\", sans-serif;\n}\n.commentText {\n  margin-top: 0;\n  padding-inline: 35px;\n  padding-top: 0;\n  font-weight: 400;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.time {\n  font-weight: 500;\n  font-family: \"Nunito\", sans-serif;\n  font-size: 14px;\n  margin-inline: 8px;\n}\n\n.modelFooter {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  padding-inline: 10px;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.modelFooter > input {\n  display: flex;\n  flex: 1;\n  height: 40px;\n  margin-inline-start: 10px;\n  padding-inline: 15px;\n  border-radius: 40px;\n  border: none;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  outline: none;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.sendBtn {\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  cursor: pointer;\n  position: absolute;\n  bottom: 29px;\n  right: 29px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #5d87ff;\n  width: 35px;\n  height: 35px;\n  border-radius: 40px;\n}\n/* img overlay */\n\n.container {\n  position: relative;\n  cursor: pointer;\n}\n\n.image {\n  opacity: 1;\n  transition: 0.5s ease;\n  backface-visibility: hidden;\n}\n\n.middle {\n  transition: 0.5s ease;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  text-align: center;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.container:hover .image {\n  filter: blur(8px);\n}\n\n.container:hover .middle {\n  opacity: 1;\n}\n\n.text {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.tagsName {\n  font-weight: 700;\n  text-transform: capitalize;\n  color: black;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.actionBtn {\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  cursor: pointer;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.disabled {\n  opacity: 0.4;\n  cursor: not-allowed !important;\n}\n\n.userBox {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.userName {\n  font-size: 0.9rem;\n  color: #11181c;\n  line-height: 1.25rem;\n  text-transform: capitalize;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.userEmail {\n  font-size: 0.75rem;\n  color: #7e868c;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.cardBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.cardOne {\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  width: 90%;\n  height: 150px;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n.NuberStyle {\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  margin-inline: 6px;\n}\n\n.countVal {\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  margin-top: 0.6rem;\n  font-size: 26px;\n  color: #5d87ff;\n  font-weight: 600;\n}\n\n.loderBox {\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.closeBtn {\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n  position: absolute;\n  top: 10px;\n  color: red;\n  cursor: pointer;\n  right: 10px;\n}\n\n.buttonAddRole {\n  align-items: center;\n  background-color: #5d87ff;\n  border: 0;\n  border-radius: 8px;\n  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;\n  box-sizing: border-box;\n  color: #ffffff;\n  display: flex;\n  font-size: 14px;\n  justify-content: center;\n  line-height: 1em;\n  max-width: 100%;\n  padding: 13px 15px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n  font-weight: 600;\n  font-family: \"Nunito\", sans-serif;\n}\n.forResponsive {\n  width: 1400px;\n  overflow: auto;\n}\n\n/* new */\n\n.boxPlay1 {\n  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,\n    rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;\n  min-height: 50vh;\n  background: #fff;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  padding-bottom: 1rem;\n}\n.boxPlay2 {\n  box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px,\n    rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;\n  height: 73vh;\n  overflow: auto;\n  background: #fff;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  padding-bottom: 1rem;\n  overflow: auto;\n\n}\n\n.sources {\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  background: #fff;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n}\n\n.lc {\n  border: 1px solid rgb(93, 91, 91);\n  padding: 0.5rem;\n  border-radius: 5px;\n  min-width: 47%;\n  margin-right: 1rem;\n  padding-bottom: 1rem;\n}\n\n.overflowBox {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow: auto;\n  padding-top: 0.2rem;\n}\n\n.boxforsource{\n  border: 1px solid rgb(93, 91, 91);\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box1": `style_box1__Bk1LT`,
	"uploadVideo": `style_uploadVideo__dQy03`,
	"pasteVideo": `style_pasteVideo__XJ5Uu`,
	"pVal": `style_pVal__-SNP9`,
	"nextBtn": `style_nextBtn__COQmf`,
	"step2Box": `style_step2Box__Mht0V`,
	"itemBox": `style_itemBox__Wzwfd`,
	"itemBox2": `style_itemBox2__4+vOp`,
	"itemBoxAdd": `style_itemBoxAdd__Uzatm`,
	"removeBtn": `style_removeBtn__vstwV`,
	"markBondary": `style_markBondary__jl5wp`,
	"flexDiv": `style_flexDiv__sijx3`,
	"titleHome": `style_titleHome__wfwZn`,
	"saveForLater": `style_saveForLater__AVCOG`,
	"cancel": `style_cancel__hq3xM`,
	"uploadBtn": `style_uploadBtn__xvWaz`,
	"connectToCamera": `style_connectToCamera__FLf1P`,
	"navHeader": `style_navHeader__KlCHX`,
	"activeHeader": `style_activeHeader__rK+qJ`,
	"dactiveHeader": `style_dactiveHeader__k+B2r`,
	"inprogress": `style_inprogress__YZLN8`,
	"boxLast": `style_boxLast__jr3oE`,
	"videoBox": `style_videoBox__JKMXp`,
	"btn1": `style_btn1__ULPvQ`,
	"countBox": `style_countBox__ZbOVB`,
	"numberBoxHead": `style_numberBoxHead__34mri`,
	"cardHome": `style_cardHome__ZOHXN`,
	"scrollableDiv": `style_scrollableDiv__pV10V`,
	"card": `style_card__LrEis`,
	"ImgBox": `style_ImgBox__efFKw`,
	"eventContent": `style_eventContent__9pa3W`,
	"warehouseBox": `style_warehouseBox__BgAEq`,
	"date": `style_date__CGqs1`,
	"alertName": `style_alertName__MEXWY`,
	"footer": `style_footer__wfmH7`,
	"footerDiv": `style_footerDiv__-nnG9`,
	"loading": `style_loading__ATmp6`,
	"viewBtn": `style_viewBtn__dSLvK`,
	"imgBoxView": `style_imgBoxView__6PyOW`,
	"crossBtn": `style_crossBtn__e1+JW`,
	"commentBox": `style_commentBox__rZ6dR`,
	"commentHeding": `style_commentHeding__zEL3d`,
	"comment": `style_comment__0CRE6`,
	"userName": `style_userName__m0cXT`,
	"commentText": `style_commentText__frWOl`,
	"time": `style_time__JQ8+w`,
	"modelFooter": `style_modelFooter__Eejni`,
	"sendBtn": `style_sendBtn__fFDYt`,
	"container": `style_container__QRVSx`,
	"image": `style_image__eC0AA`,
	"middle": `style_middle__VpEha`,
	"text": `style_text__dQkSx`,
	"tagsName": `style_tagsName__iCPyS`,
	"actionBtn": `style_actionBtn__YIPrD`,
	"disabled": `style_disabled__ITxqQ`,
	"userBox": `style_userBox__02VxE`,
	"userEmail": `style_userEmail__sUu1r`,
	"cardBox": `style_cardBox__YSV5J`,
	"cardOne": `style_cardOne__4-JPK`,
	"NuberStyle": `style_NuberStyle__1guRP`,
	"countVal": `style_countVal__jddzq`,
	"loderBox": `style_loderBox__Dq9ns`,
	"closeBtn": `style_closeBtn__PR7wD`,
	"buttonAddRole": `style_buttonAddRole__-qd-5`,
	"forResponsive": `style_forResponsive__BppiR`,
	"boxPlay1": `style_boxPlay1__c30hD`,
	"boxPlay2": `style_boxPlay2__cYJ6V`,
	"sources": `style_sources__WcQBI`,
	"lc": `style_lc__-xK5N`,
	"overflowBox": `style_overflowBox__wQFKY`,
	"boxforsource": `style_boxforsource__vx5n8`
};
export default ___CSS_LOADER_EXPORT___;
